import { html } from 'lit';
const DiscordPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M18.923 5.647a16.2 16.2 0 0 0-4.067-1.267.09.09 0 0 0-.067.029c-.171.314-.371.723-.505 1.038a15.3 15.3 0 0 0-4.571 0 10 10 0 0 0-.515-1.038c-.01-.02-.038-.029-.066-.029-1.429.248-2.79.676-4.067 1.267-.01 0-.02.01-.029.019-2.59 3.876-3.304 7.648-2.952 11.381q0 .032.029.048a16.6 16.6 0 0 0 4.99 2.524c.029.01.057 0 .067-.02.38-.523.724-1.076 1.019-1.657.019-.038 0-.076-.038-.085a12 12 0 0 1-1.562-.743c-.038-.02-.038-.076-.01-.105.105-.076.21-.162.315-.238.019-.02.047-.02.066-.01 3.277 1.496 6.81 1.496 10.048 0a.06.06 0 0 1 .067.01c.105.086.21.162.314.247.038.03.038.086-.01.105a10 10 0 0 1-1.561.743c-.038.01-.048.057-.038.086.304.58.647 1.133 1.019 1.657.028.01.057.02.085.01a16.5 16.5 0 0 0 5-2.524.05.05 0 0 0 .03-.048c.418-4.314-.696-8.057-2.953-11.381-.01-.01-.02-.02-.038-.02M8.683 14.77c-.98 0-1.8-.905-1.8-2.02s.8-2.018 1.8-2.018c1.01 0 1.81.914 1.8 2.019 0 1.114-.8 2.019-1.8 2.019m6.638 0c-.98 0-1.8-.905-1.8-2.02s.8-2.018 1.8-2.018c1.01 0 1.81.914 1.8 2.019 0 1.114-.79 2.019-1.8 2.019"/>
  </svg>
`;
export default DiscordPanel;
